import Core  from '../../../core';
import axios from 'axios';



const core = new Core('bc-banner');
const DEFAULT_BREAK_POINT = 710;
const DEFAULT_LOG_DOMAIN  = 'koukoku.benesse.ne.jp';
const IS_DEVELOP_ACCESS   = /^(localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})/.test(location.host);
const DEFAULT_TYPE_SETTING = {interval: 5};



const forceDateMatch = (location.search || '').match(/[\?&]forcedate=(\d{4})-?(\d{1,2})-?(\d{1,2})/);
const forceDate = forceDateMatch && forceDateMatch.length === 4
  ? `${forceDateMatch[1]}-${('00' + forceDateMatch[2]).slice(-2)}-${('00' + forceDateMatch[3]).slice(-2)}`
  : null;
if (forceDate) {
  console.info(`URLパラメータ「forcedate」が設定されているので表示期間検索値を「${forceDate}」で行います`);
}



export default {
  namespaced: true,

  state: {
    state: 'pending',
    dir: core.path.dir,
    IS_DEVELOP: core.IS_DEVELOP,
    IS_PRODUCTION: core.IS_PRODUCTION,
    IS_DEVELOP_ACCESS: IS_DEVELOP_ACCESS,
    year: null,
    breakPoint: DEFAULT_BREAK_POINT,
    logDomain: DEFAULT_LOG_DOMAIN,
    executionLogSendLocation: null,
    executionLogSend: null,

    // 過去設定ファイルで特定のURLの場合表示期間を無視できる機能実装を行っていたが機能削除となったため、
    // 本ステートは常にfalseとなる。
    // 念のため将来的に関連機能を実装する事になるかもしれないのでステート定義のみ残しておく。
    // 本ステートをtrueにするとdataモジュールの方で表示期間を無視してバナーをピックアップする
    // @see: https://jcomintra.backlog.jp/view/BENE_IMJ_CENTER_TEST_2018-287#comment-1191959773
    isIgnorePeriod: false,
    forceDate: forceDate,
    typeSettings: {},
    safeLogUrl: null,
  },

  getters: {
    dir: state => { return state.dir },
    year: state => { return state.year },
    breakPoint: state => { return state.breakPoint },
    configPath: state => { return core.path.join(state.dir, 'config.json') },
    logUri: state => { return location.protocol + '//' + core.path.join(state.logDomain, 'beacon', 'beacon.bcn') },
    safeLogUrl: state => state.safeLogUrl,
    joinedPath: state => paths => {
      paths = typeof paths === 'string' ? [paths] : paths;
      return core.path.join(state.dir, ...paths)
    },
    executionLogSend: state => { return state.executionLogSend },
    isIgnorePeriod: state => state.isIgnorePeriod,
    forceDate: state => state.forceDate,
    typeSetting: state => typeMaps => {
      if (!typeMaps) return DEFAULT_TYPE_SETTING;

      let matched;
      const types = typeof typeMaps === 'string' ? (typeMaps + '').replace(/\s/g, '').split(',') : typeMaps;

      for (let keyMap in state.typeSettings) {
        const typeSetting = state.typeSettings[keyMap];

        if (typeSetting.keys.length !== types.length) continue;

        let matchCount = 0;
        for (let key of types) {
          matchCount = matchCount + (typeSetting.keys.includes(key) ? 1 : -1);
        }

        if (matchCount === types.length) {
          matched = typeSetting;
          break;
        }
      }

      return matched || DEFAULT_TYPE_SETTING;
    },
  },

  actions: {
    load({dispatch, commit, state, getters}) {
      return new Promise((resolve, reject) => {
        const url = getters['configPath'];

        const onLoad = data => {
          commit('setConfig', data);
          dispatch('onLoadConfig', data, {root: true});
          return resolve(data);
        }

        const onLoadError = error => {
          return reject(new Error(error));
        }

        axios.get(url)
          .then(res => {
            const data = res.data;
            if (typeof data !== 'object') return onLoadError('広告表示設定ファイルのフォーマットが正しくありません。');
            return onLoad(data);
          })
          .catch(onLoadError);
      });
    },
  },

  mutations: {
    setConfig(state, data) {
      ['logDomain', 'year', 'breakPoint'].forEach(key => {
        if (data[key] !== undefined) state[key] = data[key];
      });

      state.safeLogUrl = data.safeLogUrl;

      const executionLogSendLocation = data.executionLogSendLocation || null;
      state.executionLogSendLocation = typeof executionLogSendLocation === 'string' ? [executionLogSendLocation] : executionLogSendLocation;

      let executionLogSend = false;
      if (state.executionLogSendLocation) {
        for (let i = 0, l = state.executionLogSendLocation.length; i < l; i++) {
          let locationTarget = state.executionLogSendLocation[i];
          locationTarget = locationTarget.replace(/\*/, '(.*?)');
          if (new RegExp(locationTarget).test(location.href)) {
            executionLogSend = true;
            break;
          }
        }
      }

      state.executionLogSend = executionLogSend;

      if (!executionLogSend) {
        console.info(`アクセス元「${location.href}」はバナー設定ファイルで許可されていないのログ送信を行いません`);
      }

      if (IS_DEVELOP_ACCESS) {
        state.logDomain = location.host;
      }

      if (data.typeSettings && typeof data.typeSettings === 'object') {
        for (let types in data.typeSettings) {
          const keys = types.split(',');
          const typeSetting = Object.assign({keys}, data.typeSettings[types]);
          state.typeSettings[types] = typeSetting;
        }
      }
    },

    setYear(state, year) {
      state.year = year;
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared/bc-banner/store/modules/config.js